import { BlobServiceClient } from '@azure/storage-blob';
import { AZURE_CDN } from '@/composable/constant';

/**
 * コンテナクライアント作成処理
 */
export function getBlobContainerClient() {
  // BlobServiceClientを作成
  const blobServiceClient = BlobServiceClient.fromConnectionString(AZURE_CDN.CONNECTSTRING);
  // コンテナクライアントを作成
  const containerClient = blobServiceClient.getContainerClient(AZURE_CDN.CONTAINERNAME);
  return containerClient;
}

/**
 * テロップ画像をBlobにアップロードする処理
 */
export async function uploadContentCaptionPngBlobStorage(contentCaptionPng, contentCaptionPngName) {
  const containerClient = getBlobContainerClient();
  // Blobクライアントを作成
  const blobName = `jauser/captionPng/${contentCaptionPngName}`;
  const blobClient = containerClient.getBlockBlobClient(blobName);
  // dataURLをバイナリデータに変換
  const byteString = atob(contentCaptionPng.split(',')[1]);
  const mimeString = contentCaptionPng.split(',')[0].split(':')[1].split(';')[0];
  const arrayBuffer = new ArrayBuffer(byteString.length);
  const uint8Array = new Uint8Array(arrayBuffer);

  for (let i = 0; i < byteString.length; i += 1) {
    uint8Array[i] = byteString.charCodeAt(i);
  }

  // Blobにアップロード
  const blobOptions = { blobHTTPHeaders: { blobContentType: mimeString } };
  await blobClient.uploadData(uint8Array, blobOptions);
}

/**
 * テロップ画像をBlobから削除する処理
 */
export async function deleteContentCaptionPngBlobStorage(contentCaptionPngName) {
  const containerClient = getBlobContainerClient();
  // Blobクライアントを作成
  const blobName = `jauser/captionPng/${contentCaptionPngName}`;
  const blobClient = containerClient.getBlockBlobClient(blobName);

  // Blobから削除
  await blobClient.delete();
}
